import Badge from 'react-bootstrap/Badge'
import Stack from 'react-bootstrap/Stack'
import {
  formatCurrency,
  isOrderPartiallyRefunded,
  getOrderTotalRefundedAmount,
  paymentStatuses,
} from '../../../../../utilities/helpers'

export default function OrderBadges({ order }) {
  const badges = []

  // if (order?.package_tickets?.length > 0) {
  //   badges.push(
  //     <Badge key="package-badge" bg="none" className={`badge-sm badge--open`}>
  //       Package
  //     </Badge>,
  //   );
  // }

  // Add payment status badge
  if (order?.status && paymentStatuses[order?.status]) {
    if (
      order?.status.toLowerCase() !== 'released' &&
      order?.status.toLowerCase() !== 'refunded'
    ) {
      const status = paymentStatuses[order?.status]
      badges.push(
        <Badge
          key="payment-status"
          bg="none"
          className={`badge-sm badge--${status.value}`}
        >
          {status.longLabel}
        </Badge>
      )
    }
  }

  if (isOrderPartiallyRefunded(order)) {
    const totalRefunded = getOrderTotalRefundedAmount(order)
    const partialStatus = paymentStatuses.partially_refunded
    badges.push(
      <Badge
        key="partial-refund-status"
        bg="none"
        className={`badge-sm badge--${partialStatus.value}`}
        title={
          totalRefunded > 0
            ? `${formatCurrency(totalRefunded)} refunded to date`
            : undefined
        }
      >
        {partialStatus.longLabel}
      </Badge>
    )
  }

  // Add source label badge
  // if (order?.type && typeStatuses[order?.type]) {
  //     const typeLabel = typeStatuses[order?.type];
  //     badges.push(
  //         <Badge
  //             key="source-label"
  //             bg="none"
  //             className={`badge-sm badge--${typeLabel.value}`}
  //         >
  //             {typeLabel.label}
  //         </Badge>
  //     );
  // }

  return (
    <Stack direction="horizontal" gap={2}>
      {badges}
    </Stack>
  )
}
